import React, { useRef } from "react";
import cx from "classnames";
import { Tooltip, Text } from "@showitinc/showit-wc";
import styles from "./PanelHeader.module.css";
import AppConstants from "../../constants/AppConstants";
import openRowContextMenu from "../../utils/openRowContextMenu";
/**
 * Panel Header
 * Includes icon, title, and dropdown actions, used in both Site and Page Panel
 * @component
 * @param {object} props
 * @param {object} props.children - Dropdown actions
 * @param {string} props.label - header name
 * @param {function} props.onSelect - (page panel) function to run when clicked
 * @param {boolean} props.selected - (page panel) is the header selected
 * @param {string} props.panelType - type of panel the header is currently in (page | site)
 * @param {string} props.tooltip - optional tooltip text for the header
 * @returns {React.ReactElement}
 */

const { SITE_ITEM_SITE, SITE_ITEM_PAGE } = AppConstants;

const PanelHeader = ({
  children,
  label,
  onSelect,
  selected,
  backToPageButton,
  panelType = "",
  tooltip,
}) => {
  const rootRef = useRef(null);
  return (
    <div
      ref={rootRef}
      className={cx(styles.root, {
        [styles.active]: selected,
      })}
      onClick={onSelect}
      onContextMenu={(e) =>
        openRowContextMenu({
          event: e,
          rowEl: rootRef.current,
          active: selected,
          select: onSelect,
        })
      }
    >
      <div
        className={cx(styles.header, {
          [styles["pages-panel"]]: panelType === SITE_ITEM_SITE,
          [styles["layers-panel"]]: panelType === SITE_ITEM_PAGE,
        })}
      >
        {backToPageButton}
        {tooltip ? (
          <Tooltip relative position="bottom-right" delay={250}>
            <span className={styles.label}>{label}</span>
            <div slot="content">
              <Text>{tooltip}</Text>
            </div>
          </Tooltip>
        ) : (
          <span className={styles.label}>{label}</span>
        )}
      </div>
      <div className={styles.menu}>{children}</div>
    </div>
  );
};

export default PanelHeader;
